window.Vue = require('vue').default;
require('./bootstrap');
require('./vue/vue');


/**
 *Check if you are offline
 */
window.addEventListener('online', displayOfflineStatus);
window.addEventListener('offline', displayOfflineStatus);

if (!navigator.onLine) {
    $('.js__alert-offline').show();
}

/**
 * Display an error message if you're offline
 */
function displayOfflineStatus() {
    if (navigator.onLine) {
        $('.js__alert-offline').slideUp(500); // Remove the no internet alert first
        $('.js__alert-online').slideDown(500);
        setTimeout(() => {
            $('.js__alert-online').slideUp(500);
        }, 3000);
    } else {
        $('.js__alert-online').slideUp(500); // remove the 'there is internet alert first
        $('.js__alert-offline').slideDown(500);
    }
}


$(document).on('click', '.js__mark-all-notifications-as-read', (e) => {
    axios.post('/api/internal/notifications/mark-all-as-read', {
        user_id: USER_ID
    }).then((response) => {
        NioApp.Toast(response.data, 'success', {position: 'top-right', timeOut: 5000});
    }).catch((errors) => {
        console.log(errors);
    });
});


/**
 * Global connect always to this channel, since it hold the user notifications
 */
// if (USER_ID.length) {
//
//     window.Echo.private(`App.Models.User.${USER_ID}`)
//         .subscribed((e) => {
//             console.log('Subscribed to user notifications channel');
//         })
//         .error((e) => {
//             console.log(e)
//         })
//         .listen('.user-notification', (notification) => {
//             console.log('Got notification!');
//             console.log(notification);
//
//             NioApp.Toast(notification.message, 'success', {position: 'top-right', timeOut: 5000});
//         });
// }
